export const tabsData = [
  {
    tabLabel: 'yourTabLabelName',
    color: '#000000',
    video:
      'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/TearsOfSteel.mp4',
  },
  {
    tabLabel: 'yourTabLabelName',
    color: '#000000',
    video:
      'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4',
  },
  {
    tabLabel: 'yourTabLabelName',
    color: '#000000',
    video:
      'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/Sintel.mp4',
  },
  {
    tabLabel: 'yourTabLabelName',
    color: '#000000',
    video:
      'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
  },
];
